module.exports = __webpack_public_path__ + "5980a2f050c6e99826625ab14e3a79ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NonAuthHomePage/components/Description/images/web2_2x.png
// module id = Z7Z1
// module chunks = 13